import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, effect, EventEmitter, inject, Input, input, OnInit, Output, output, signal, viewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { AgGridAngular, AgGridModule } from "ag-grid-angular";
import { CellValueChangedEvent, ColDef, GridApi, GridReadyEvent, RowClickedEvent, RowDoubleClickedEvent, RowSelectedEvent, RowSelectionOptions } from "ag-grid-community";
import { isNumber } from "class-validator";
import { AgCheckBoxEditor, AgGridService, ColumnModi, CR, GridInitOption, JkBaseComponent, JkeditComponent, JkExcelService, jkLib, JkPaginatorService, login, MaterialModule, numberFormatter, openWinClass, OpenWinLoadOption } from "jk-service";
import { idNameItem, jkRestReturn } from 'jk-service';
import { BookType } from "xlsx";
import { JkGridBaseFatherComponent } from "./jkgrid-base-father";
@Component({
  selector: 'app-jkgrid-base',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(window:resize)': 'onWindowResize()',
  },
  imports: [
    CommonModule,
    FormsModule,
    AgGridModule,
    MaterialModule,
  ],
  templateUrl: './jkgrid-base.component.html',
  styles: [],
  providers: [AgGridService],
})

export class JkGridBaseComponent extends JkGridBaseFatherComponent implements OnInit {
  override comType = 'jkgridbase';
  openwinIn = new openWinClass();
  openwinColumnDef = new openWinClass();
  value = input<any>();
  /*params = input<any[]>([]);
  _params = computed(() => this.params());
  // 在方法中操作
  modifyParams() {
    const currentParams = this.params(); // 獲取當前值
    const newParams = [...currentParams, 1, 2]; // 建立新數組

    // 通過輸出事件告訴父組件更新
    this.valueChange.emit(newParams);
  }
  // 或只在計算中使用
  computedParams = computed(() => {
    const arr = [...this.params()]; // 複製數組
    // 對 arr 進行修改操作...
    return arr;
  });
  */
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() params: any[] = [];
  paramIn: any[] = [];
  onValueChange(newValue: any) {
    this.valueChange.emit(newValue);
  }
  // Convert getter/setter for maintable
  //private _maintable: string = '';
  set maintable(value: string) {
    //this._maintable = value;
    this.openwinIn.mainTable = value;
  }
  get maintable(): string {
    return this.openwinIn.mainTable;
  }

  // Convert getter/setter for mainItem
  //private _mainItem: string = '';
  set mainItem(value: string) {
    //this._mainItem = value;
    this.openwinIn.item = value;
  }
  get mainItem(): string {
    return this.openwinIn.item;
  }

  // Convert getter/setter for type
  private _type: string = 'W';
  set type(value: string) {
    this._type = value;
    this.openwinIn.type = value;
  }
  get type(): string {
    return this._type;
  }

  // Convert getter/setter for where
  private _where: string = '';
  set where(value: string) {
    this._where = value;
    this.openwinIn.where = value;
  }
  get where(): string {
    return this._where;
  }

  // Convert getter/setter for order
  private _order: string = '';
  set order(value: string) {
    this._order = value;
    //this.openwinIn.orderBy = value;
    this.openwinIn.order = value;
  }
  get order(): string {
    return this._order;
  }

  constructor() {
    super();
    effect(() => {
      this._height.set(this.height());
    });
    /*
    effect(() => {
      const paramValue = this.params();
      // 在這裡處理參數變化 (如發送事件給父組件)
      this.valueChange.emit(paramValue);
    });*/
    /*
    // 響應式地監聽 itemListInput 變化並同步到 itemList
    effect(() => {
      const inputItems = this.itemListInput();
      if (inputItems !== undefined) {
        this._itemList.set(inputItems);
      }
    });*/
  }
  override ngOnInit() {
    super.ngOnInit();
    this._gridStyle = this.gridSrv.gridStyle;
    // itemListInput 的同步現在由 constructor 中的 effect 處理
    // 無需手動賦值，effect 會自動響應變化
  }



  get itemFocused(): any {
    let cnt = this.itemList.length;
    if (this.focusedRowIndex >= 0) {
      return this.itemList[this.focusedRowIndex];
    } else {
      let obj = {};
      return obj;
    }
  }

  set itemFocused(item: any) {
    if (
      this.focusedRowIndex >= 0 &&
      this.focusedRowIndex < this.itemList.length
    ) {
      const currentList = [...this.itemList];
      currentList[this.focusedRowIndex] = item;
      this.setItemList(currentList);
      /*this.itemList = currentList;
      this.pageSrv.getPager(this.itemList);
      this.itemListChange.emit(this.itemList);*/
    }
  }
  _itemList: Array<any> = [];
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()
  get itemList(): Array<any> {
    return this._itemList;
  }
  /*set itemList(value: Array<any>) {
    this._itemList = [...value];
    //this.pageSrv.getPager(this.itemList);
    //this.itemListChange.emit(this.itemList);
  }*/

  setItemList(value: any[]) {
    this._itemList = value;
    this.pageSrv.getPager(this.itemList);
    this.itemListChange.emit(this.itemList);
    this.cdr.markForCheck();
  }
  selectionFilter: any[] = [];
  _keyExpr: string[] = [];
  set keyExpr(value: string[]) {
    this._keyExpr = value;
  }
  get keyExpr(): string[] {
    return this._keyExpr;
  }
  get selectedKeyValues(): string {
    let s = '';
    // if (!this.grid) return s;
    if (this.valueExpr() === '') {
      return s;
    }
    for (let i = 0; i < this.selectedRowsData.length; i++) {
      // TODO:
      //let keyValue = this.grid.selectedRowKeys[i][this.valueExpr];
      //s += jkLib.iif(s === '', '', ',') + keyValue;
    }
    return s;
  }



  focusedRowKey: any = undefined;
  fields!: Array<any>;

  setColumnDisplayDataType(data: any[]) {
    try {
      let item = data[0];
      if (!item) return;
      let keys = Object.keys(item);
      for (let i = 0; i < this.columnDefs.length; i++) {
        let col = this.columnDefs[i];
        if (col.field) {
          let value = item[col.field];
          if (true) {
            if (isNumber(value)) {
              col.cellDataType = 'number';
              col.cellStyle = { 'text-align': 'right' };
              col.valueFormatter = numberFormatter;
            }
            if (
              col.cellDataType === 'text' &&
              (value === 'Y' || value === 'N')
            ) {
              col.cellRenderer = AgCheckBoxEditor;
            }
          }
        }
      }
    } catch (error: any) {
      console.error('setColumnDisplayDataType error:', error.message);
    }
  }

  // 與 based.SetFieldLabel 功能同步修改
  async setColumnDisplay(openwinIn: openWinClass) {
    //let columnDefs = [...this.columnDefs];
    this.columnDefs = [];
    this.updateColumnsCount();
    // openwin sqlReturn 來預設 keyExpr, displayExpr
    let expr = openwinIn.sqlReturn.split(',');
    if (expr.length >= 2) {
      if (this.keyExpr.length === 0) {
        let keyList = expr[0].split(',');
        this.keyExpr = [...keyList];
      }
      if (openwinIn.displayExpr === '') openwinIn.displayExpr = expr[1];
    }
    let labelList: string[] = [];
    /*if (openwinIn.display.includes(CR))
      labelList = openwinIn.display.split(CR)
    else*/
    labelList = openwinIn.display.split('\n');
    let fontSize = 12;
    this.columnDefs = this.gridSrv.geneColumnListDisplay(
      this.columnDefs,
      labelList,
      fontSize
    );
    // Note: Need to handle the columnDefs assignment properly
    this.updateColumnsCount();
    this.doAfterColumndefs();
    if (this.afterColumnDefs) {
      this.afterColumnDefs.emit(this.columnDefs);
    }
    this.cdr.markForCheck();
  }
  doAfterColumndefs() { }
  comReady($e: any, comName: string) {
    if (comName === 'gridwinPaginator')
      // 似乎沒在用
      this.paginator = $e;
  }
  reorderColumn(item: any, columnDefs: ColDef[]) {
    if (!item) return;
    let colTemp: ColDef[] = [];
    let colList = Object.keys(item);
    for (let i = 0; i < colList.length; i++) {
      let col = columnDefs.find(x => x.field === colList[i]);
      if (col) {
        colTemp.push(col);
      }
    }
    this.gridApi.setGridOption("columnDefs", colTemp);
  }

  /**
   * 實際取得 Grid 資料
   */
  doOpenGrid(opt: OpenWinLoadOption) {
    this.orm.doOpenwin(opt)
      .subscribe((data: any) => {
        if (data.result) {
          this.setColumnDisplayDataType(data.obj);
          this.setItemList(data.obj);
          if (this.itemList.length > 0) {
            this.reorderColumn(this.itemList[0], this.columnDefs);
          }
          if (this.afterQuery) {
            if (this.itemList.length > 0)
              this.afterQuery.emit(this.itemList);
            else {
              // console.log('jkgridwin.afterQuery: maintable '+this.maintable+' itemList is empty');
            }
          }
        } else {
          alert(data.errorLog);
        }
      });
  }

  getColumnDefs(opt: OpenWinLoadOption, isGetData: boolean = true) {
    /*this.orm.login = this.login;
    if (this.orm.login.host === '') {
      alert('getColumnDefs:orm:login.host is null');
      return;
    }*/
    this.orm
      .getopenwin(opt.mainTable, opt.item, opt.type) //只取 openwin 不取資料
      .subscribe({
        next: (data: any) => {
          if (data.result) {
            this.orm.parseOpenwin(data, this.openwinColumnDef);
            this.setColumnDisplay(this.openwinColumnDef);
            this.setOrderList(this.openwinColumnDef.order);
            this.doOpenGrid(opt);
          } else {
            alert(data.errorLog);
          }
        },
        error: (error: any) => {
          let msg = 'jkgridwin getopenwin error:' + error.message;
          alert(msg);
          console.error(msg);
        },
      });
  }
  orderItemId: string = '';
  orderList: idNameItem[] = [];

  setOrderList(order: string) {
    let sqlOrder = order.split(CR);
    this.orderList = [];
    for (let i = 0; i < sqlOrder.length; i++) {
      if (sqlOrder[i].trim() === '') continue;
      let field = jkLib.getToken(sqlOrder[i], ';', 1);
      let fieldName = jkLib.getToken(sqlOrder[i], ';', 2);
      let orderBy = jkLib.getToken(sqlOrder[i], ';', 3);
      if (orderBy === '') {
        orderBy = field;
      }
      let where = jkLib.getToken(sqlOrder[i], ';', 4);
      if (where === '') {
        where = field;
      }
      if (i === 0) {
        this.orderItemId = field;
      }
      this.orderList.push({ id: field, name: fieldName, ps1: orderBy, ps2: where });
    }
    this.cdr.markForCheck();
  }

  override onGridReady(event: GridReadyEvent) {
    super.onGridReady(event);
    const paginatorInstance = this.paginator;
    if (paginatorInstance) {
      this.pageSrv.setObj(paginatorInstance, this.itemList);
    }

  }


  doItemList() {
    this.page
      .showInput('json內容', '輸入管理員密碼', '', 'password')
      .subscribe((pw: any) => {
        if (pw === 'jenny2000') {
          this.doShowJson(this.itemList);
        }
      });
  }
  /**
   * @property {string} bookType - 匯出檔案類型
   */
  //bookType: BookType = 'xlsx';
  /**
   * @method doExport
   * @description 匯出資料為指定格式（如 xlsx, csv 等）
   */
  /*doExport() {
    this.bookType = this.bookTypeItem.id as BookType;
    this.xls.jsonExport(this.itemList, jkLib.nowDate() + '-' + jkLib.nowTime6() + '.' + this.bookType, this.bookType );
  }*/

  // page navigate -------------------------
  onPageChange(event: PageEvent) {
    this.pageSrv.handlePageEvent(event);
  }

  override onNextRow() {
    super.onNextRow();

  }
  gridMove(step: number) {
    // TODO: 移動 grid row
  }
  openwinItemStr(): string {
    let msg = `${this.openwinIn.mainTable}-${this.openwinIn.item}-${this.openwinIn.type} 欄位數:${this.columnDefs.length}`;
    msg += `\n`;
    msg += ' height:' + this.gridStyle['height'];
    msg += ' width:' + this.gridStyle['width'];
    msg += ' minHeight:' + this.minHeight();
    msg += ' maxHeight:' + this.maxHeight();
    return msg;
  }
  override doShowInfo($event: MouseEvent) {
    super.doShowInfo($event);
    const pw = this.page
      .showInput('開窗設定', '輸入管理員密碼', '', 'password')
      .subscribe(async (pw: any) => {
        if (pw === 'jenny2000') {
          let msg = '開窗設定:' + this.openwinItemStr();
          await this.page.showMessage(msg);
        }
      });
  }

  onSumAll() {
    this.gridSrv.onSumAll(this.itemList, this.columnDefs);
  }

  override doRefresh() {
    super.doRefresh();
    this.doOpenGrid(this.openwinIn.getOpenWinLoadOption());
  }

  //gridVisible: boolean = true;
  override doUIRefresh(isResetPage = true) {
    super.doUIRefresh(isResetPage);
    /*this.gridVisible = false;
    setTimeout(() => {
      this.gridVisible = true;
      this.cdr.markForCheck();
    }, 1);
    */
  }


  override onPreviousRow() {
    super.onPreviousRow();
    // Re-apply current itemList to paginator after page change
    this.pageSrv.getPager(this.itemList);
  }
  get openwinLabel() {
    return '開窗(' + this.openwinIn.mainTable + '-' + this.openwinIn.item + ')';
  }
  override itemListLength(): number {
    return this.itemList.length;
  }

  //adjustHeight = input<number>(140);

  //height = signal<number>(window.innerHeight - 20);
  height = input<number>(window.innerHeight - 20);
  private _height = signal<number>(window.innerHeight - 20); // computed(() => this.height());
  heightChange(value: number) {
    let newH = value; // - this.adjustHeight();
    if (newH < this.minHeight()) newH = this.minHeight();
    if (this.maxHeight() && newH > this.maxHeight()) newH = this.maxHeight();
    this._height.set(newH);
  }
  get heightValue(): number {
    return this._height();
  }
  maxHeight = input<number>(1000);
  get maxHeightValue(): number {
    return this.maxHeight();
  }
  minHeight = input<number>(200);
  //defaultHeight = input<number>(300);
  override onWindowResize() {
    super.onWindowResize();
    //this.heightChange(window.innerHeight - this.adjustHeight());
  }
  /**
   * @method calculateHeight
   * @description 計算網格高度，包含高度控制邏輯
   * @returns {number} 計算後的高度值
   */
  protected calculateHeight(): number {
    let calculatedHeight = this.height() || this.defaultHeight();
    // 應用最小高度限制
    if (calculatedHeight < this.minHeight()) {
      calculatedHeight = this.minHeight();
    }
    // 應用最大高度限制
    if (this.maxHeight() && calculatedHeight > this.maxHeight()) {
      calculatedHeight = this.maxHeight();
    }
    return calculatedHeight;
  }
  private _gridStyle: Record<string, string | number> = {};
  get gridStyle(): Record<string, string | number> {
    const calculatedHeight = this.calculateHeight();
    this._gridStyle['height'] = calculatedHeight + 'px';
    return this._gridStyle;
  }
  set gridStyle(value: Record<string, string | number>) {
    this._gridStyle = value;
  }
  defineOpenGrid(defineWin: openWinClass) {
    //let opt: OpenWinLoadOption = defineWin.getOpenWinLoadOption();
    this.openwinColumnDef.assign(defineWin);
    this.setColumnDisplay(defineWin);
    //this.setOrderList(defineWin.order);
    //this.doOpenGrid(opt);
    //let sql = defineWin.sqlSelect;
    if (defineWin.sqlSelect.indexOf("/*WHERE*/") > 0) {
      defineWin.sqlSelect = jkLib.replaceLine(defineWin.sqlSelect, "/*WHERE*/", defineWin.where);
    } else {
      //sql = sql + " /*WHERE*/ WHERE 1=1 " + defineWin.where;
    }
    if (defineWin.order !== "") {
      defineWin.order = defineWin.checkOrderBy(defineWin.order);
      if (defineWin.sqlSelect.indexOf("/*ORDER*/") > 0) {
        defineWin.sqlSelect = jkLib.replaceLine(defineWin.sqlSelect, "/*ORDER*/", defineWin.order || '');
      } else {
        //sql = sql + " /*ORDER*/ " + this.order;
      }
    }

    this.orm.simpleSql(login.host, defineWin.sqlSelect).subscribe((data: any) => {
      this.setColumnDisplayDataType(data);
      this.setItemList(data);
      if (this.itemList.length > 0) {
        this.reorderColumn(this.itemList[0], this.columnDefs);
      }
      if (this.afterQuery) {
        if (this.itemList.length > 0)
          this.afterQuery.emit(this.itemList);
        else {
          // console.log('jkgridwin.afterQuery: maintable '+this.maintable+' itemList is empty');
        }
      }
    });
  }

}
